export const ACCOUNT_TYPE={
    STUDENT:"Student",
    INSTRUCTOR:"Instructor",
    ADMIN:"Admin"
}
